// GENERATED by scripts/generate-build-info.js on every build. Do not edit by hand.
// Checked in so the build works before the script has run (a fresh clone, an IDE type-check).
export const BUILD_INFO = {
  commit: '04afb54d3b86',
  version: '4.0.0',
};
